import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="status"
export default class extends Controller {
  connect() {
    setTimeout(
      () => {
        this.element.innerText = "";
      },
      this.data.get("timeout") || 3000,
    );
  }
}
